module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "toast-view"
  }, [_c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showToast('Normal')
      }
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showToast('Success')
      }
    }
  }, [_vm._v("Sucess")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showToast('Loading')
      }
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showToast('Cus')
      }
    }
  }, [_vm._v("Custom Icon")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-5e091580!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/toastView.vue
// module id = 249
// module chunks = 0